import ClientSelectedFiltersBuilder from '../models/filters/client/ClientSelectedFiltersBuilder';

export default {
  /**
   *
   * @param state
   * @param value{AwardsResult}
   */
  setAwardsResult(state, value) {
    state.awardsData = value.awardsData;
    state.filterEngine = Object.freeze(value.filterForm);
    state.selectedFilters = ClientSelectedFiltersBuilder.build(state.filterEngine);
    state.isFiltersPanelDataLoaded = true;
    // state.awardsResult = value;
  },

  updateAwardsData(state, value) {
    // state.awardsResult?.updateAwardData(awardsData);
    state.awardsData = value.awardsData;
  },

  /**
   *
   * @param state
   * @param value{LeaderboardResult}
   */
  setLeaderboardResult(state, value) {
    state.leaderboardResult = value;
    state.filterEngine = Object.freeze(value.filterForm);
    state.leaderboardResult.filterForm = null;
    state.selectedFilters = ClientSelectedFiltersBuilder.build(state.filterEngine);
    state.isFiltersPanelDataLoaded = true;
  },

  /**
   *
   * @param state
   * @param value{Leaderboard}
   */
  updateLeaderboard(state, value) {
    state.leaderboardResult?.updateLeaderboard(value);
  },

  incrementFilterVersion(state) {
    state.filterVersion += 1;
  },

  setSelectedFilters(state, value) {
    state.selectedFilters = value;
  },

  setAwardFilters(state, value) {
    state.filterEngine = Object.freeze(value);
    state.selectedFilters = ClientSelectedFiltersBuilder.build(state.filterEngine);
    state.isFiltersPanelDataLoaded = true;
  },

  setAwardsResultData(state, value) {
    state.awardsData = value.awardsData;
  },

  setCadreRankingsData(state, value) {
    state.cadreRankingsData = value;
  },

  setFiltersPanelDataLoadedStatus(state, value) {
    state.isFiltersPanelDataLoaded = value;
  },
};
